<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/shared/lib/utils'

defineOptions({ inheritAttrs: false })

const props = defineProps<{
  class?: HTMLAttributes['class']
  label?: string
}>()
</script>

<template>
  <!-- mobile-only spacer: reserves bar footprint (gap 12px + bar 64px = 76px; h-20=80px rounds up) -->
  <div class="h-20 md:hidden" aria-hidden="true" />

  <!-- docked bar -->
  <div
    :role="label ? 'group' : undefined"
    :aria-label="label"
    :class="cn(
      'fixed inset-x-0 z-30 border-t border-border bg-background px-4 pt-5 pb-2 md:hidden',
      'bottom-[calc(var(--bottomnav-height)+env(safe-area-inset-bottom,0px)+0.75rem)]',
      props.class
    )"
  >
    <div class="flex items-center gap-2 [&>*:last-child]:flex-1">
      <slot />
    </div>
  </div>
</template>
